import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import play from "../../assets/images/Google_Play_Store_badge_EN_1.png";
import apple from "../../assets/images/Group_165074.png";
import mockup from "../../assets/images/Risoapp_1.png"; 

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 750,
  maxWidth: '95%',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  fontFamily: "'Kumbh Sans'",
  display: 'flex',
  overflow: 'hidden',
  flexDirection: { xs: 'column', sm: 'row' },

};

function Comming({ open, handleClose }) {
  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="download-app-modal-title"
    >
      <Box sx={style}>
        {/* Left Image Side */}
        <Box sx={{ flex: 1, backgroundColor: '#f9f9f9', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
          <img src={mockup} alt="App Preview" style={{ width: '100%', maxWidth: '220px', borderRadius: '12px' }} />
        </Box>

        {/* Right Content Side */}
        <Box sx={{ flex: 1.5, p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
            Download Our Application
          </Typography>
          <Typography sx={{ mb: 3, color: 'text.secondary' }}>
            Start your career journey with us — available on Play Store and App Store.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
              <img src={play} alt="Google Play" style={{ height: '50px' }} />
            </a>
            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
              <img src={apple} alt="App Store" style={{ height: '50px' }} />
            </a>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default Comming;

